import React from "react";
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Spin,
  InputNumber,
  Divider,
  Space,
  Button,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const { Text, Title } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    currencyData,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
    periodFrequencyTypeOptions,
    lockinPeriodFrequencyTypeOptions,
  } = props;
  // const isWithdrawalFeeForTransfers = Form.useWatch(
  //   "withdrawalFeeForTransfers",
  //   form
  // );
  const isAllowOverdraft = Form.useWatch("allowOverdraft", form);
  const isLienAllowed = Form.useWatch("lienAllowed", form);
  // const isEnforceMinRequiredBalance = Form.useWatch(
  //   "enforceMinRequiredBalance",
  //   form
  // );

  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={initialValues}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInformation}
          </Title>
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name={"interestCompoundingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name={"interestPostingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestPostingPeriod, "select")}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name={"interestCalculationType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestCalculatedUsing, "select")}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name={"interestCalculationDaysInYearType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.daysInYear),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInYear, "select")}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.additionalInfo}
          </Title>
        </Divider>
        {/* Deposit Details */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.depositAmount}
            name={"depositAmount"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.depositAmount),
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.depositAmount)}
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.depositPeriod}
            name={"depositPeriod"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.depositPeriod),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.depositPeriod)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.depositPeriodType}
            name={"depositPeriodFrequencyId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.depositPeriodFrequency),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.depositPeriod, "select")}
              options={periodFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.lockInPeriod} name={"lockinPeriodFrequency"}>
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockinPeriodFrequencyType}
            name={"lockinPeriodFrequencyType"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod, "select")}
              options={lockinPeriodFrequencyTypeOptions}
              showSearch
              allowClear
            />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"isUpfrontFeesCollection"} label={"Collect interest upfront"}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
              // onChange={handleDormancyTracking}
            />
          </Form.Item>
        </Col> */}
      </Row>
    </Form>
  );
};

export default TermsForm;
